import vendorDashboardAPI from '@/utils/api/vendorDashboard';
import { genericError, genericSuccess } from '@/utils/alerts.service';
import { itemCRUD } from '@/store/vendorDashboard/modules/itemCRUD';

export const tiers = {
  namespaced: true,
  state: {
    ...itemCRUD.state(),
  },
  getters: {
    ...itemCRUD.getters,
  },
  mutations: {
    ...itemCRUD.mutations,

    setTiers(state, data) {
      data.sort((a, b) => a.order - b.order);
      data.forEach((a, b) => (a.order = b));
      return (state.items = data);
    },
  },
  actions: {
    ...itemCRUD.actions,

    addDirtyTab({ commit }) {
      commit('settings/addDirtyTab', 'tiers', { root: true });
    },

    async fetchTiers({ dispatch, commit }) {
      return vendorDashboardAPI
        .getTiers()
        .then(data => {
          commit('setTiers', data.results);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async saveTiers({ state, commit, dispatch }) {
      const data = [...state.items, ...state.itemsToDelete];

      for (let i of data) {
        if (!i.name) {
          return dispatch(
            'showUserMessage',
            {
              success: false,
              title: 'Oops!',
              message: 'Please make sure all tiers have a name.',
            },
            { root: true }
          );
        }
      }

      return vendorDashboardAPI
        .saveTiers(data)
        .then(res => {
          dispatch('showUserMessage', { ...genericSuccess }, { root: true });
          commit('setTiers', res.data);
          commit('setTiers', res.data, { root: true });
          commit('clearItems');
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },
  },
};
